import React, { Component } from "react";
import $ from "jquery";
import {
  shuffle,
  isEqual,
  filter,
  find,
  cloneDeep,
  concat,
  orderBy,
  sumBy,
  max,
  indexOf,
  remove,
} from "lodash";
import LineTo from "react-lineto";
import FlipMove from "react-flip-move";
import okButtonIcon from "../../../../assets/images/okbutton_icon.png";
import okButtonDisabledIcon from "../../../../assets/images/okbutton_disabled.png";

//-----------------------------------------------------------------------------
// Matching Question Type - MAT - Draw Lines Between Boxed Pairs
//-----------------------------------------------------------------------------
class MATTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
      matLeftOptionsArray: [],
      matRightOptionsArray: [],
      expectedMATAnswers: [],
      actualMATAnswers: [],
      selectedLeftOption: null,
      selectedRightOption: null,
      currentQuestionDeductionScore: 0,
      optionsLoaded: false,
      matOptionsAnimateSpeed: "1",
      currentLine: null,
    };
  }
  componentDidMount() {
    const { currentQuestion } = this.props;
    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines
      );
    }
  }

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount
  ) => {
    let {
      matLeftOptionsArray,
      matRightOptionsArray,
      expectedMATAnswers,
    } = this.state;
    let generatedAnswersArray = [];

    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let answerTypeSplittedArray = item.split("|");
        answerTypeSplittedArray = filter(answerTypeSplittedArray);
        if (answerTypeSplittedArray.length === 2) {
          let splittedArray = answerTypeSplittedArray[1].split("=");
          return splittedArray[0] !== ""
            ? {
                id: index + 1,
                pairMatch1: splittedArray[0],
                pairMatch2: splittedArray[1],
                match1Id: "match_" + index + "_1",
                match2Id: "match_" + index + "_2",
                answerType: answerTypeSplittedArray[0],
              }
            : null;
        } else {
          let splittedArray = answerTypeSplittedArray[0].split("=");
          return splittedArray[0] !== ""
            ? {
                id: index + 1,
                pairMatch1: splittedArray[0],
                pairMatch2: splittedArray[1],
                match1Id: "match_" + index + "_1",
                match2Id: "match_" + index + "_2",
                answerType: "T",
              }
            : null;
        }
      }
    );
    generatedAnswersArray = this.props.getRandomAnswers(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    matLeftOptionsArray = generatedAnswersArray.map((elem, elemIndex) => {
      return {
        matchId: elem.match1Id,
        matchOptionText: elem.pairMatch1,
        isMatched: 0,
        matchedWith: "",
        answerType: elem.answerType,
      };
    });
    matRightOptionsArray = generatedAnswersArray.map((elem, elemIndex) => {
      return {
        matchId: elem.match2Id,
        matchOptionText: elem.pairMatch2,
        isMatched: 0,
        matchedWith: "",
        answerType: elem.answerType,
      };
    });

    if (isRandomAnswers === "1") {
      matLeftOptionsArray = shuffle(matLeftOptionsArray);
    }
    matRightOptionsArray = shuffle(matRightOptionsArray);

    expectedMATAnswers = generatedAnswersArray.map((elem, elemIndex) => {
      return { id1: elem.match1Id, id2: elem.match2Id };
    });

    this.setState(
      {
        generatedAnswers: generatedAnswersArray,
        matLeftOptionsArray: matLeftOptionsArray,
        matRightOptionsArray: matRightOptionsArray,
        expectedMATAnswers: expectedMATAnswers,
        optionsLoaded: false,
      },
      () => {
        $(".single-option").css("height", "auto");
        this.props.setMATOptionsCount(
          this.state.actualMATAnswers.length,
          this.state.expectedMATAnswers.length
        );
      }
    );
  };

  onClickLeftOption = (data) => {
    let {
      actualMATAnswers,
      selectedLeftOption,
      selectedRightOption,
    } = this.state;
    if (
      find(actualMATAnswers, { id1: data.matchId }) &&
      !selectedLeftOption &&
      !selectedRightOption
    ) {
      actualMATAnswers = actualMATAnswers.filter(function (elem, index) {
        return elem.id1 !== data.matchId;
      });
      if (!selectedRightOption) {
        data = null;
      }
    }
    if (selectedLeftOption && !selectedRightOption) {
      data = null;
    }
    this.setState(
      {
        selectedLeftOption: data,
        actualMATAnswers: actualMATAnswers,
      },
      () => {
        this.setOptionsLink();
      }
    );
  };

  onClickRightOption = (data) => {
    let {
      actualMATAnswers,
      selectedLeftOption,
      selectedRightOption,
    } = this.state;

    if (
      find(actualMATAnswers, { id2: data.matchId }) &&
      !selectedLeftOption &&
      !selectedRightOption
    ) {
      actualMATAnswers = actualMATAnswers.filter(function (elem, index) {
        return elem.id2 !== data.matchId;
      });
      if (!selectedLeftOption) {
        data = null;
      }
    }
    if (!selectedLeftOption && selectedRightOption) {
      data = null;
    }
    this.setState(
      {
        selectedRightOption: data,
        actualMATAnswers: actualMATAnswers,
      },
      () => {
        this.setOptionsLink();
      }
    );
  };

  setOptionsLink = () => {
    let {
      actualMATAnswers,
      selectedLeftOption,
      selectedRightOption,
    } = this.state;

    let currentLine = null;

    if (selectedLeftOption) {
      if (selectedRightOption) {
        let leftMatchedElement = find(actualMATAnswers, {
          id1: selectedLeftOption.matchId,
        });
        let rightMatchedElement = find(actualMATAnswers, {
          id2: selectedRightOption.matchId,
        });

        if (leftMatchedElement) {
          //replace if left element already exist
          let matchedLeftElementIndex = indexOf(
            actualMATAnswers,
            leftMatchedElement
          );
          leftMatchedElement.id2 = selectedRightOption.matchId;
          leftMatchedElement.isCorrect = 0;
          leftMatchedElement.isMarkedWrong = 0;
          if (selectedRightOption) {
            leftMatchedElement.answerType = selectedRightOption.answerType;
          }
          currentLine = leftMatchedElement;
          actualMATAnswers.splice(
            matchedLeftElementIndex,
            1,
            leftMatchedElement
          );
        } else if (rightMatchedElement) {
          //replace if right element already exist

          let matchedRightElementIndex = indexOf(
            actualMATAnswers,
            rightMatchedElement
          );
          rightMatchedElement.id1 = selectedLeftOption.matchId;
          rightMatchedElement.isCorrect = 0;
          rightMatchedElement.isMarkedWrong = 0;
          if (selectedRightOption) {
            rightMatchedElement.answerType = selectedRightOption.answerType;
          }
          // rightMatchedElement.answerType = rightMatchedElement.answerType;
          currentLine = rightMatchedElement;
          actualMATAnswers.splice(
            matchedRightElementIndex,
            1,
            rightMatchedElement
          );
        } else {
          currentLine = {
            id1: selectedLeftOption.matchId,
            id2: selectedRightOption.matchId,
            answerType: selectedRightOption.answerType,
            isCorrect: 0,
            isMarkedWrong: 0,
          };
          actualMATAnswers.push(currentLine);
        }
        selectedLeftOption = null;
        selectedRightOption = null;
      }
    }
    this.setState(
      {
        actualMATAnswers: actualMATAnswers,
        selectedLeftOption: selectedLeftOption,
        selectedRightOption: selectedRightOption,
        currentLine: currentLine,
      },
      () => {
        this.reArrangeOptionsArray();
      }
    );
  };

  reArrangeOptionsArray = () => {
    let {
      matLeftOptionsArray,
      matRightOptionsArray,
      actualMATAnswers,
    } = this.state;

    let allLeftOptions = cloneDeep(matLeftOptionsArray);
    let allRightOptions = cloneDeep(matRightOptionsArray);

    let answersLeftIds = actualMATAnswers.map((e) => e.id1);
    let answersRightIds = actualMATAnswers.map((e) => e.id2);

    let correctLeftData = filter(
      answersLeftIds.map((leftId) => {
        return find(allLeftOptions, { matchId: leftId });
      })
    );
    let correctRightData = filter(
      answersRightIds.map((rightId) => {
        return find(allRightOptions, { matchId: rightId });
      })
    );

    allLeftOptions = filter(matLeftOptionsArray, (left) => {
      return !answersLeftIds.includes(left.matchId);
    });
    allRightOptions = filter(matRightOptionsArray, (right) => {
      return !answersRightIds.includes(right.matchId);
    });

    matLeftOptionsArray = concat(correctLeftData, allLeftOptions);
    matRightOptionsArray = concat(correctRightData, allRightOptions);

    let newAnswers = [];

    if (correctLeftData.length > 0 && correctRightData.length > 0) {
      correctLeftData.forEach((element, index) => {
        newAnswers.push({
          id1: element.matchId,
          id2: correctRightData[index].matchId,
          isCorrect: find(actualMATAnswers, { id1: element.matchId }).isCorrect,
          isMarkedWrong: find(actualMATAnswers, { id1: element.matchId })
            .isMarkedWrong,
          answerType: correctRightData[index].answerType,
        });
      });
    }
    newAnswers = orderBy(newAnswers, "isCorrect", "desc");
    let originalAnswers = cloneDeep(newAnswers);
    if (this.state.currentLine) {
      remove(newAnswers, {
        id1: this.state.currentLine.id1,
        id2: this.state.currentLine.id2,
      });
    }
    this.setState(
      {
        matLeftOptionsArray,
        matRightOptionsArray,
        actualMATAnswers: newAnswers,
      },
      () => {
        setTimeout(() => {
          this.setState(
            {
              actualMATAnswers: originalAnswers,
            },
            () => {
              this.props.setMATOptionsCount(
                this.state.actualMATAnswers.length,
                this.state.expectedMATAnswers.length
              );
            }
          );
        }, 500);
      }
    );
  };

  getRemainingTriesText = () => {
    switch (this.state.currentQuestionDeductionScore) {
      case 0:
        return "";
      case 50:
        return "2 Attempts Remaining";
      /*
      case 20:
        return "5 Attempts Remaining";
      case 40:
        return "4 Attempts Remaining";
      case 60:
        return "3 Attempts Remaining";
      case 80:
        return "2 Attempt Remaining";
      */
      case 100:
        return "1 Attempt Remaining";
      default:
        return "";
    }
  };
  onFinish = () => {
    if (!this.state.optionsLoaded) {
      setTimeout(() => {
        let allHeightValues = [];
        $(".single-option").each(function () {
          allHeightValues.push($(this).height());
        });
        let maxHeight = max(allHeightValues);
        console.log();

        $(".single-option").css(
          "cssText",
          "height: " + maxHeight + "px !important;"
        );
        this.setState({
          optionsLoaded: true,
          matOptionsAnimateSpeed: "300",
        });
      }, 100);
    }
  };

  onClickVerifyMATAnswer = () => {
    let {
      actualMATAnswers,
      expectedMATAnswers,
      matLeftOptionsArray,
      matRightOptionsArray,
    } = this.state;

    let { currentQuestion, currentQuestionId } = this.props;
    actualMATAnswers.forEach((element) => {
      if (find(expectedMATAnswers, { id1: element.id1, id2: element.id2 })) {
        element.isCorrect = 1;
        element.isMarkedWrong = 0;
      } else {
        element.isCorrect = 0;
        element.isMarkedWrong = 1;
      }
    });
    actualMATAnswers = orderBy(actualMATAnswers, ["isCorrect"], ["desc"]);

    let leftArray = [],
      rightArray = [];

    actualMATAnswers.forEach((element) => {
      let leftElement = find(matLeftOptionsArray, { matchId: element.id1 });
      let rightElement = find(matRightOptionsArray, { matchId: element.id2 });
      if (element.isCorrect === 1) {
        leftElement.isMatched = 1;
        rightElement.isMatched = 1;
      } else {
        leftElement.isMatched = 0;
        rightElement.isMatched = 0;
      }
      leftArray.push(leftElement);
      rightArray.push(rightElement);
    });
    matLeftOptionsArray = leftArray;
    matRightOptionsArray = rightArray;

    matLeftOptionsArray.forEach((element) => {
      if (find(actualMATAnswers, { id1: element.matchId, isCorrect: 1 })) {
        element.isMatched = 1;
      } else {
        element.isMatched = 0;
      }
    });
    matRightOptionsArray.forEach((element) => {
      if (find(actualMATAnswers, { id2: element.matchId, isCorrect: 1 })) {
        element.isMatched = 1;
      } else {
        element.isMatched = 0;
      }
    });
    this.setState(
      {
        actualMATAnswers: actualMATAnswers,
        matLeftOptionsArray: matLeftOptionsArray,
        matRightOptionsArray: matRightOptionsArray,
      },
      () => {
        if (this.props.isTest) {
          //It is test: count points and move to next question

          let questionDetails = {
            number: currentQuestionId,
            questionText: currentQuestion.QLong,
            QTypeShort: currentQuestion.QTypeShort,
            questionGraphicUrl: currentQuestion.QGraphicURL,
            expectedAnswersCount: this.state.expectedMATAnswers.length,
            correctAnswersCount: sumBy(
              this.state.actualMATAnswers,
              "isCorrect"
            ),
            answers: filter(this.state.actualMATAnswers, { isCorrect: 0 }),
            matLeftOptionsArray: this.state.matLeftOptionsArray,
            matRightOptionsArray: this.state.matRightOptionsArray,
          };
          questionDetails.isCorrect = isEqual(
            questionDetails.expectedAnswersCount,
            questionDetails.correctAnswersCount
          )
            ? 1
            : 0;
          this.props.addAttendedQuestion(questionDetails);
          this.setState({
            actualMATAnswers: [],
            expectedMATAnswers: [],
            matLeftOptionsArray: [],
            matRightOptionsArray: [],
          });
        } else {
          // It is quiz: deduct 50% for wrong questions and allow to try again.
          let { currentQuestionDeductionScore } = this.state;
          let correctCount = sumBy(this.state.actualMATAnswers, "isCorrect");
          let totalCount = this.state.expectedMATAnswers.length;

          if (correctCount === totalCount) {
            //All answers are true, give point and move to next question

            let questionDetails = {
              number: currentQuestionId,
              questionText: currentQuestion.QLong,
              QTypeShort: currentQuestion.QTypeShort,
              questionGraphicUrl: currentQuestion.QGraphicURL,
              expectedAnswersCount: totalCount,
              correctAnswersCount: correctCount,
              answers: filter(this.state.actualMATAnswers, { isCorrect: 0 }),
              matLeftOptionsArray: this.state.matLeftOptionsArray,
              matRightOptionsArray: this.state.matRightOptionsArray,
              deductionPercentage: currentQuestionDeductionScore,
            };
            questionDetails.isCorrect = isEqual(totalCount, correctCount)
              ? 1
              : 0;

            this.props.addAttendedQuestion(questionDetails);
            this.setState({
              actualMATAnswers: [],
              expectedMATAnswers: [],
              matLeftOptionsArray: [],
              matRightOptionsArray: [],
              currentQuestionDeductionScore: 0,
            });
          } else {
            if (currentQuestionDeductionScore < 100) {
              //deduct 50% from total points and allow to try again -  total 3 tries

              this.setState({
                currentQuestionDeductionScore:
                  currentQuestionDeductionScore + 50,
              });
            } else {
              // all tries completed, give scores for this question and move to next question

              let questionDetails = {
                number: currentQuestionId,
                questionText: currentQuestion.QLong,
                QTypeShort: currentQuestion.QTypeShort,
                questionGraphicUrl: currentQuestion.QGraphicURL,
                expectedAnswersCount: totalCount,
                correctAnswersCount: correctCount,
                answers: filter(this.state.actualMATAnswers, { isCorrect: 0 }),
                matLeftOptionsArray: this.state.matLeftOptionsArray,
                matRightOptionsArray: this.state.matRightOptionsArray,
                deductionPercentage: currentQuestionDeductionScore,
              };
              questionDetails.isCorrect = isEqual(totalCount, correctCount)
                ? 1
                : 0;
              this.props.addAttendedQuestion(questionDetails);
              this.setState({
                actualMATAnswers: [],
                expectedMATAnswers: [],
                matLeftOptionsArray: [],
                matRightOptionsArray: [],
                currentQuestionDeductionScore: 0,
              });
            }
          }
        }
      }
    );
  };

  render() {
    const {
      matLeftOptionsArray,
      matRightOptionsArray,
      actualMATAnswers,
      selectedLeftOption,
      selectedRightOption,
      matOptionsAnimateSpeed,
      expectedMATAnswers,
    } = this.state;
    const { questionSetDetails } = this.props;
    const remainingTriesText = this.getRemainingTriesText();

    return (
      <div className="answer-options-container">
        {actualMATAnswers.map((lineElement, index) => {
          return (
            <React.Fragment key={"line-" + index}>
              <LineTo
                from={lineElement.id1}
                to={lineElement.id2}
                fromAnchor="middle right"
                toAnchor="middle left"
                borderWidth={10}
                borderColor={
                  lineElement.isCorrect
                    ? "#25E154"
                    : lineElement.isMarkedWrong === 1
                    ? "#7f797d"
                    : "#fff"
                }
                delay={600}
                className={"line-rearrange"}
              />
            </React.Fragment>
          );
        })}

        <div className="mat-container">
          {!this.props.isTest && remainingTriesText && (
            <div className="remaining-attempts-text">{remainingTriesText}</div>
          )}
          <div className="mat-options-container">
            <div className="left-options-container">
              <FlipMove
                staggerDurationBy="10"
                duration={matOptionsAnimateSpeed}
                enterAnimation="accordionVertical"
                leaveAnimation="accordionVertical"
                onFinishAll={this.onFinish}
              >
                {matLeftOptionsArray.map((option, index) => {
                  return (
                    <div
                      className={
                        "single-option " +
                        option.matchId +
                        (selectedLeftOption &&
                        selectedLeftOption.matchId === option.matchId
                          ? " selected-option"
                          : "")
                      }
                      key={option.matchId}
                      onClick={
                        option.isMatched === 1
                          ? () => {}
                          : () => this.onClickLeftOption(option)
                      }
                    >
                      {option.matchOptionText}
                    </div>
                  );
                })}
              </FlipMove>
            </div>
            <div className="right-options-container">
              <FlipMove
                staggerDurationBy="10"
                duration={matOptionsAnimateSpeed}
                enterAnimation="accordionVertical"
                leaveAnimation="accordionVertical"
                onFinishAll={this.onFinish}
                onStartAll={this.onStart}
              >
                {matRightOptionsArray.map((option, index) => {
                  return (
                    <div
                      className={
                        "single-option " +
                        option.matchId +
                        (selectedRightOption &&
                        selectedRightOption.matchId === option.matchId
                          ? " selected-option"
                          : "")
                      }
                      key={option.matchId}
                      onClick={
                        option.isMatched === 1
                          ? () => {}
                          : () => this.onClickRightOption(option)
                      }
                    >
                      {option.answerType === "P" ? (
                        <img
                          src={
                            questionSetDetails.QSResourcePath +
                            option.matchOptionText
                          }
                          alt="matching-graphic"
                        />
                      ) : (
                        option.matchOptionText
                      )}
                    </div>
                  );
                })}
              </FlipMove>
            </div>
          </div>
        </div>
        <div className="submit-btn-container">
          <div
            className="submit-btn"
            onClick={
              actualMATAnswers.length === expectedMATAnswers.length
                ? this.onClickVerifyMATAnswer
                : () => {}
            }
          >
            <div className="submit-btn-icon">
              <img
                src={
                  actualMATAnswers.length === expectedMATAnswers.length
                    ? okButtonIcon
                    : okButtonDisabledIcon
                }
                alt="ok-icon"
              />
            </div>
            <div className="submit-btn-text">Submit</div>
          </div>
        </div>
      </div>
    );
  }
}

export default MATTypeQuestion;
